import React from "react";
import { CustomerAvatar } from "../../otc-requests/components/CustomerAvatar";

interface CustomerCellProps {
  name: string;
}

export const CustomerCell: React.FC<CustomerCellProps> = ({ name }) => {
  return (
    <div className="flex items-center gap-2 max-w-[155px]">
      <CustomerAvatar name={name} size={20} />
      <span className="truncate text-[13px] font-normal text-[#344054]" title={name}>
        {name || "N/A"}
      </span>
    </div>
  );
};
